import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var FormatClearIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M18.784 8.892l4.243 4.242a1 1 0 010 1.414l-8.014 8.014a1 1 0 01-1.415 0L9.356 18.32a1 1 0 010-1.415l8.014-8.013a1 1 0 011.414 0zM14.55 14.54l-3.073 3.072 2.829 2.829 3.067-3.067-2.823-2.834zM8.908 2.58l4.034 8.74-1.68 1.68H4.486l-1.578 3.42a1 1 0 01-1.816-.84l6-13a1 1 0 011.816 0zM8 5.387L5.41 11h5.181l-2.59-5.614z",
                        fillRule: "evenodd"
                    })
                })
            })
        ]
    });
};
FormatClearIcon.isCarinaIcon = true;
export default FormatClearIcon;
